import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaTID = (): TabelaColuna => ({
  Chave: 'tid',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 130 }}>TID</div>
})
